module.exports = __webpack_public_path__ + "static/media/sack.ff3e2d8a.svg";